import { createSlice } from '@reduxjs/toolkit';
import { fetchPortfolioPage } from '../../api/publicApi'; // Adjust the import path as necessary
import {fetchTouchpoints} from "../../api/userApi";

const initialState = {
    disclaimerSeen: false,
    email: null,
    portfolioMetadata: {

    },
    portfolioPage: null,
    touchpoints: [],
    loading: false,
    error: null,
    isPublicAccess: false // New flag to indicate public access

};

const publicSlice = createSlice({
    name: 'public',
    initialState,
    reducers: {
        markDisclaimerAsSeen(state) {
            state.disclaimerSeen = true;
        },
        setEmail(state, action) {
            state.email = action.payload;

        },
        setPublicAccess(state, action) { // New action to set public access flag
            state.isPublicAccess = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPortfolioPage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchPortfolioPage.fulfilled, (state, action) => {
                state.portfolioPage = action.payload;
                state.loading = false;
            })
            .addCase(fetchPortfolioPage.rejected, (state, action) => {
                state.error = action.payload;
                state.loading = false;
            })
            .addCase(fetchTouchpoints.fulfilled, (state, action) => {
                state.status = 'succeeded';
                // This replaces any existing touchpoint_details with the fetched data
                state.touchpoints = action.payload.map(tp => ({
                    id: tp.id,
                    content: tp.content
                }));
            })
    }
});

export const { markDisclaimerAsSeen, setEmail, setPublicAccess } = publicSlice.actions;



export const selectPortfoliosMetadata = (state, ids) => {
  if (!ids || !Array.isArray(ids)) return [];
  return ids.map(id => ({id, ...state.public.portfolioMetadata[id] || {}}));
};

export default publicSlice.reducer;
